var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }